<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<br/><p style="text-indent:00em;">Lesley has always enjoyed writing but began doing so in earnest when she retired from her post as a primary school headteacher.</p>
<br/><p style="text-indent:00em;">She has always been interested in the supernatural and mystery, and is also an avid reader.</p>
<br/><p style="text-indent:00em;">She lives in North Tyneside, with her pet Fox Terrier, Darcy, and has three daughters.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f95bb42c